import * as types from '../constants/ActionTypes'

export const loadedAnimateccJS = () => ({ type: types.LOADED_ANIMATECC_JS })
export const startCanvas = () => ({ type: types.START_CANVAS })
export const setMouseDown = (isMouseDown) => ({ type: types.SET_MOUSE_DOWN, isMouseDown })
export const setNumMouseOver = (numMouseOver) => ({ type: types.SET_NUM_MOUSE_OVER, numMouseOver })
export const setScrollPosition = (inRange, isMin, isMax) => ({ type: types.SET_SCROLL_POSITION, inRange, isMin, isMax })



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/